import { injectable } from 'inversify-props'
import { EntradaDeTitulo, SituacaoDoTitulo } from '@/models/financeiro/Titulo'
import {
	create,
	findTitulos,
	getTitulo,
	update,
	deleteById,
	updateTitulos,
} from '@/api/titulos'
import { TituloServiceAdapter } from '@/usecases/titulos'
import { AxiosRequestConfig } from 'axios'

@injectable()
export class TituloService implements TituloServiceAdapter {
	create = async (titulo: EntradaDeTitulo) => await create(titulo)
	update = async (titulo: EntradaDeTitulo) => await update(titulo)
	find = async (params?: any, config?: AxiosRequestConfig) => await findTitulos(params, config)
	get = async (id: string) => await getTitulo(id)
	delete = async (id: string) => await deleteById(id)
	updateTitulos = async (titulosId: string[], situacaoDoTitulo: SituacaoDoTitulo) => await updateTitulos(titulosId, situacaoDoTitulo)
}
